import { render, staticRenderFns } from "./DeliveryWaitingToday.vue?vue&type=template&id=bf47ee68&"
import script from "./DeliveryWaitingToday.vue?vue&type=script&lang=js&"
export * from "./DeliveryWaitingToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports